import React from "react"
import PropTypes from "prop-types"
import Info from "./Info"
import {
  Button,
  Form,
  Grid,
  Header,
  Input,
  Modal,
  Card,
} from "semantic-ui-react"
import Pagination from "./Pagination"
import EditableTable from "./EditableTable"
import bind from "bind-decorator"
import DateRangePicker from "./DateRangePicker"
import Datetime from "react-datetime"
import "react-datetime/css/react-datetime.css"
import moment from "moment"
import { withTranslation } from "react-i18next"

// TODO: fix export button layout
class EditableDiscountTableHolder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: "",
      innerTableData: null,
      isExporting: false,
      addDiscountModal: false,
      discountName: "",
      discountPercent: "",
      discountStores: [],
      fromDate: null,
      toDate: null,
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    if (newProps.isLoading && this.state.innerTableData) {
      this.setState({ innerTableData: null })
    }
  }

  @bind
  handleExport() {
    const { onExport } = this.props
    this.setExporting(true)
    onExport(this.setExporting)
  }

  @bind
  setExporting(flag) {
    this.setState({ isExporting: flag })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  setQuery({}, { value }) {
    this.setState({
      searchQuery: value,
    })
  }

  @bind
  selectItem(selected) {
    if (this.props.innerTable) {
      const {
        innerTable: { propName },
      } = this.props
      this.setState({ innerTableData: selected[propName] })
    }
  }

  @bind
  onModalClose() {
    this.setState({ innerTableData: null })
  }

  @bind
  search() {
    const { searchQuery } = this.state
    const { onSearch } = this.props
    onSearch(searchQuery)
  }

  @bind
  handleAddDiscount() {
    this.setState({
      addDiscountModal: !this.state.addDiscountModal,
    })
  }

  @bind
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  handleSelect({}, { value, name }) {
    this.setState({
      [name]: value,
    })
  }

  handleSaveFromDate(from) {
    this.setState({
      fromDate: moment(from).format(),
    })
  }

  handleSaveToDate(to) {
    this.setState({
      toDate: moment(to).format(),
    })
  }

  @bind
  createDiscount() {
    const data = {
      stores: this.state.discountStores,
      discount: {
        title: this.state.discountName,
        percent: parseInt(this.state.discountPercent),
        startedAt: this.state.fromDate,
        finishAt: this.state.toDate,
      },
    }
    this.props.onCreate(data)
    this.setState({
      addDiscountModal: false,
    })
  }
  render() {
    const { t } = this.props
    const {
      title,
      info,
      onExport,
      exportInfo,
      pagesCount,
      currentPage,
      onPageSelect,
      searchInfo,
      innerTable,
      isLoading,
      tableData,
      onSetDateRange,
      startDate,
      endDate,
      noOptions,
      noOptionsNested,
      totalCount,
      okAlco,
      palyonka,
      storeOptions,
      discountOptions,
      addItemsToDiscount,
    } = this.props

    const {
      innerTableData,
      searchQuery,
      discountStores,
      discountName,
      discountPercent,
    } = this.state

    return (
      <div className="editable-table-holder">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2 style={{ margin: 0 }}>
            {title}
            <Info text={info} />
          </h2>
          {onSetDateRange && (
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              onRangeChange={onSetDateRange}
            />
          )}

          {this.props.button && (
            <Button
              color="green"
              content={t("addDiscount")}
              onClick={this.handleAddDiscount}
            />
          )}
        </div>
        {/* <Grid>
          <Grid.Row verticalAlign="middle">
            { <Grid.Column mobile={16} tablet={6} computer={8}>
              {
                <Form onSubmit={this.search}>
                  <Form.Field>
                    <Input
                      className="editable-table-holder-search"
                      icon={<Info text={searchInfo} />}
                      value={searchQuery}
                      onChange={this.setQuery}
                      placeholder="Поиск"
                    />
                  </Form.Field>
                </Form>
              }
            </Grid.Column> }
            { <Grid.Column mobile={16} tablet={10} computer={8}>
              { <Pagination
                max={4}
                count={pagesCount}
                current={currentPage}
                onSelect={onPageSelect}
              /> }
              {onExport && (
                <div className="export-button-holder">
                  <Button
                    className="export-button"
                    content="Скачать"
                    color="green"
                    loading={isExporting}
                    onClick={this.handleExport}
                  />
                  <Info text={exportInfo} />
                </div>
              )}
            </Grid.Column> }
          </Grid.Row>
        </Grid> */}
        {this.state.addDiscountModal && (
          <Modal
            open
            onClose={this.handleAddDiscount}
            closeIcon="close"
            style={{ position: "fixed", top: "15%" }}
            size="small"
          >
            <Header>{t("createNewDiscount")}</Header>
            <Modal.Content>
              <Card.Content key="1">
                <Form>
                  <Form.Input
                    label={t("titleDiscount")}
                    type="text"
                    id="discountName"
                    name="discountName"
                    value={discountName}
                    onChange={this.handleChange}
                  />
                  <div style={{ width: "100" }}>
                    <div
                      style={{
                        width: "49%",
                        float: "left",
                      }}
                    >
                      <Form.Input
                        label={t("discountPercent")}
                        type="number"
                        id="discountPercent"
                        name="discountPercent"
                        value={discountPercent}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div style={{ width: "49%", float: "right" }}>
                      <Form.Select
                        multiple
                        options={storeOptions}
                        label={t("stores")}
                        id="discountStores"
                        name="discountStores"
                        value={discountStores}
                        onChange={this.handleSelect}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100" }}>
                    <div
                      style={{
                        width: "49%",
                        float: "left",
                        marginBottom: "20px",
                        marginTop: "20px",
                      }}
                    >
                      <span>
                        <b>{t("from")}</b>
                      </span>
                      <Datetime
                        locale="ru"
                        closeOnSelect
                        timeFormat={false}
                        dateFormat="DD.MM.YYYY г."
                        onChange={(value) => this.handleSaveFromDate(value)}
                      />
                    </div>
                    <div
                      style={{
                        width: "49%",
                        float: "right",
                        marginTop: "20px",
                      }}
                    >
                      <span>
                        <b>{t("to")}</b>
                      </span>
                      <Datetime
                        locale="ru"
                        closeOnSelect
                        timeFormat={false}
                        dateFormat="DD.MM.YYYY г."
                        onChange={(value) => this.handleSaveToDate(value)}
                      />
                    </div>
                  </div>
                </Form>
              </Card.Content>
              <Modal.Actions
                style={{
                  float: "right",
                  marginTop: "20px",
                  marginBottom: "10px",
                }}
              >
                <Button
                  content={t("cancel")}
                  onClick={this.handleAddDiscount}
                />
                <Button
                  color="green"
                  content={t("create")}
                  onClick={this.createDiscount}
                />
              </Modal.Actions>
            </Modal.Content>
          </Modal>
        )}
        <h2>{`${t("allSupplies")}: ${totalCount}`}</h2>
        {/* <h2>{`Пей на здоровье: ${okAlco}`}</h2>
        <h2>{`Паленая: ${palyonka}`}</h2> */}
        <EditableTable
          title={title}
          {...tableData}
          isLoading={isLoading}
          onSelect={innerTable ? this.selectItem : null}
          noOptions={noOptions}
          discountOptions={discountOptions}
          addItemsToDiscount={addItemsToDiscount}
          onModalClose={this.onModalClose}
        />
        {innerTable && innerTableData && (
          <Modal
            open
            onClose={this.onModalClose}
            closeIcon="close"
            style={{ position: "fixed", top: "15%" }}
          >
            <Header as="h3">
              {innerTable.title}
              <Info text={innerTable.info} />
            </Header>
            <Modal.Content scrolling>
              <EditableTable
                {...innerTable.tableData}
                isLoading={isLoading}
                data={innerTableData}
                noOptions={noOptionsNested}
                onModalClose={this.onModalClose}
              />
            </Modal.Content>
          </Modal>
        )}
      </div>
    )
  }
}

EditableDiscountTableHolder.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string,
  exportInfo: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onExport: PropTypes.func,
  pagesCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageSelect: PropTypes.func.isRequired,
  searchInfo: PropTypes.string,
  tableData: PropTypes.shape(EditableTable.propTypes).isRequired,
  isLoading: PropTypes.bool,
  innerTable: PropTypes.shape({
    propName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    info: PropTypes.string,
    tableData: PropTypes.shape(EditableTable.propTypes).isRequired,
  }),
  noOptions: PropTypes.bool,
  noOptionsNested: PropTypes.bool,
  totalCount: PropTypes.number,
}

export default withTranslation()(EditableDiscountTableHolder)
